module.exports = __webpack_public_path__ + "static/media/3_1.69ba4acf.png";